import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-organizer',
  templateUrl: './organizer.component.html',
  styleUrls: ['./organizer.component.css']
})
export class OrganizerComponent {
    window:any=<any>window;
    notification:any = {
        danger: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'danger'}}),
        success: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'success'}})
    };

    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    updateView:any = () => {
        setTimeout(() => {
        this.cd.detectChanges();
        if(!!this.queryparams()['rule-selected']) this.openRule();
        if(!this.queryparams()['organizer-type']) this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "organizer-type" : "risorse" }) });
        if(!this.queryparams()['resource-selected']) this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "resource-selected" : this.getResources()[0]?.public_token || null }) });
        if(!!this.queryparams()['resource'] && this.queryparams()['resource'] == 'new') {
            this.openModal('#newResourceModal');
        } else this.closeModal('#newResourceModal');
        }, 50);
    };
    rand = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };
    getFormattedTime = (new_date:any = new Date()) => {
        let hours = `${new_date.getHours()}`.padStart(2, "0"),
            minutes = `${new_date.getMinutes()}`.padStart(2, "0");
        return `${hours}:${minutes}`;
    };

    resource_model:any = {
        name: '',
        configuration: {
            label: '',
            owner: this.window.appInfo.public_token_parent,
            timestamp_before: -1,
            user_bookable: false,
            availability: {
            time: {
            value: 30,
            no_rules: true,
            rules: []
            },
            quantity: {
            value: -1
            }
        }
        }
    };
    rule_model:any = {
        id: this.rand(),
        from: this.getFormattedTime(),    // L'ora di inizio es.: 9:00
        to: this.getFormattedTime(),      // L'ora di fine es.: 18:00
        start_timestamp: new Date(),    // Data di inizio della disponibilità (UNIX TIMESTAMP)
        frequency: "una-tantum",                  // "weekly", "biweekly", "monthly", "annually", "una-tantum" / Cadenza con la quale c'è disponibilità
        week: "0",                       // Settimana in cui c'è disponibilità (se biweekly sarà 0 per settimane pari, 1 per settimane dispari)
        day: "0"                         // Giorno della settimana in cui c'è disponibilità (es.: "0" = disponibilità il lunedì)
    };
    appuntamento_model:any = {
        name: '',
        start_timestamp: new Date(),
        configuration: {
            parent: this.window.appInfo.public_token_parent,
            boocal: {
                resource: "",
                targets: [],
                group: "",
                private_group: false
            },
            note: ''
        }
    };
    temp_slot:any = {
        value: 0
    };

    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router
    ) {
        route.queryParams.subscribe((p:any) => this.updateView());
    }

    ngOnViewInit() {
        this.window?.bigBucket?.element?.addEventListener("change", this.updateView.bind(this));
    };

    ngOnDestroy() {
        this.window?.bigBucket?.element?.removeEventListener("change", this.updateView.bind(this));
    };

    initResourceModel = () => {
        this.resource_model = {
            name : this.window.usher.getPublicToken(),
            configuration: {
                label: '',
                owner: this.window.appInfo.public_token_parent,
                timestamp_before: -1,
                user_bookable: false,
                availability: {
                    time: {
                        value: 30,
                        no_rules: true
                    },
                    quantity: {
                        value: -1
                    }
                }
            }
        };
    };

    initAppuntamentoModel = () => {
        this.appuntamento_model = {
            name: '',
            start_timestamp: new Date(),
            configuration: {
                parent: this.window.appInfo.public_token_parent,
                boocal: {
                    resource: "",
                    targets: [],
                    group: "",
                    private_group: false
                },
                note: ''
            }
        };
    };

    openModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`).children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'block');
    };

    closeModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`)?.children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'none');
    };
    
    get = (pt:any = null) => this.window?.emitter.getEvents()?.filter(e => e.configuration.type == 'boocal' && (!pt || e.public_token == pt)) || [];

    getCurrentAppuntamenti = () => this.get().filter((ev:any) => {
        let temp_type = this.queryparams()['organizer-type'],
            type = temp_type == 'appuntamenti' ? 'accepted' : temp_type;
        if(this.queryparams()['organizer-type'] == 'appuntamenti') return this.getCurrent().isBetween(ev.start_timestamp, ev.end_timestamp, 'day', '[]') && ev.configuration.status == type;
        return ev.configuration.status == type;
    });

    getResources = (pt:any = null) => this.window?.bigBucket?.getBuckets()[this.window.appInfo.buckets.bigBucket.boocal]?.objects?.filter(e => e.configuration.type == 'boocal' && (!pt || e.public_token == pt)) || [];

    getResource = () => {
        if(!!this.queryparams()['resource-selected']) return this.getResources(this.queryparams()['resource-selected'])[0] || this.resource_model;
        return this.resource_model;
    };

    getAppuntamento = () => {
        if(!!this.queryparams()['organizer-appuntamento']) return this.get(this.queryparams()['organizer-appuntamento']) || this.appuntamento_model;
        return this.appuntamento_model;
    };

    getRules = (id:any = null) => this.getResource().configuration?.availability?.time?.rules?.filter(e => !id || e.id == id) || [];
    
    getRule = () => {
        //if(!!this.queryparams()['rule-selected']) return this.getRules(this.queryparams()['rule-selected'])[0];
        return this.rule_model;
    };
  
    addAppuntamentoUser = (event:any) => {
        this.getAppuntamento().configuration.boocal.private_group = false;
        this.getAppuntamento().configuration.boocal.targets = this.getAppuntamento().configuration.boocal.targets || [];
        if(!event.target.value || !!this.getAppuntamento().configuration.boocal.targets.find(e => e == event.target.value)) return;
        this.getAppuntamento().configuration.boocal.targets.push(this.window.usher.getChildren().find(e => e.public_token == event.target.value).public_token);
    };
    
    addAppuntamentoGroup = (event:any) => {
        let id = event.target.value;
        this.getAppuntamento().configuration.boocal.targets.length = 0;
        this.getAppuntamento().configuration.boocal.private_group = false;
        this.getAppuntamento().configuration.boocal.group = id;
        this.getAppuntamento().configuration.boocal.targets.push(...this.window.usher.getChildren().filter(e => e.public_configuration.groups?.find(el => el.id == id)).map(e => e.public_token));
    };
    
    setAppuntamentoPrivateGroup = (event:any) => {
        this.getAppuntamento().configuration.boocal.targets.length = 0;
        this.getAppuntamento().configuration.boocal.group = "";
    };

    open = () => {
        if(this.queryparams()['organizer-type'] == 'appuntamenti') return this.openModal('#newAppuntamentoModal');
        this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "resource" : 'new' }) });
    };
    
    close = () => {
        if(this.queryparams()['resource']) {
            this.initResourceModel();
            return this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "resource" : undefined }) });
        }
        if(this.queryparams()['organizer-type'] == 'appuntamenti') {
            this.initAppuntamentoModel();
            return this.closeModal('#newAppuntamentoModal');
        }
    };

    openRule = () => {
        if(!!this.queryparams()['rule-selected']) {
        let rule = this.getRules(this.queryparams()['rule-selected'])[0];
        this.rule_model.id = rule.id || this.rand();
        this.rule_model.from = rule.from || this.getFormattedTime();
        this.rule_model.to = rule.to || this.getFormattedTime();
        this.rule_model.start_timestamp = rule.start_timestamp || new Date();
        this.rule_model.frequency = rule.frequency || "una-tantum";
        this.rule_model.week = rule.week || "0";
        this.rule_model.day = rule.day || "0";
        this.temp_slot.value = (+this.getRule()?.to?.split(":")[0] || 0)*60 + (+this.getRule()?.to?.split(":")[1] || 0);
        }
        this.openModal('#ruleModal');
    };

    closeRule = () => {
        this.rule_model = {
        from: this.getFormattedTime(),    // L'ora di inizio es.: 9:00
        to: this.getFormattedTime(),      // L'ora di fine es.: 18:00
        start_timestamp: new Date(),    // Data di inizio della disponibilità (UNIX TIMESTAMP)
        frequency: "una-tantum",                  // "weekly", "biweekly", "monthly", "annually", "una-tantum" / Cadenza con la quale c'è disponibilità
        week: "0",                       // Settimana in cui c'è disponibilità (se biweekly sarà 0 per settimane pari, 1 per settimane dispari)
        day: "0"                         // Giorno della settimana in cui c'è disponibilità (es.: "0" = disponibilità il lunedì)
        }
        this.temp_slot.value = 0;
        if(this.queryparams()['rule-selected']) this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "rule-selected" : undefined }) });
        this.closeModal('#ruleModal');
    };

    openConfirm = () => {
        this.openModal('#deleteResourceModal');
    };

    closeConfirm = () => {
        this.closeModal('#deleteResourceModal');
    };

    check = () => {
        return true;
    };

    checkRule = () => {
        return true;
    };

    handleResource = async (type:any) => {
        if(!this.check()) return;
        try {
            this.getResource().configuration.label = this.getResource().configuration.label || this.getResource().name;
        let resource = await this.window.sf.utils.$http({
            method: type == 'updateresource' ? "PUT" : "POST",
            url: `${this.window.appInfo.url_php}/endpoint.php/resource`,
            headers: {
            "Content-Type": "application/json; charset=utf-8"
            },
            data : {
            private_token: this.window.usher.getPrivateToken(),
            public_token_bucket: this.window.appInfo.buckets.bigBucket.boocal,
            resource: this.queryparams()['resource'] == 'new' ? this.resource_model : this.getResource()
            }
        });
        if(type == 'newresource') this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "resource-selected" : resource?.public_token }) });
        this.close();
        } catch(e) {
        console.log(e);
        }
        return;
    };

    deleteResource = async () => {
        if(!this.queryparams()['resource-selected']) return this.closeConfirm();
        try {
        await this.window.sf.utils.$http({
            method: "DELETE",
            url: `${this.window.appInfo.url_php}/endpoint.php/resource`,
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data : {
                private_token: this.window.usher.getPrivateToken(),
                public_token_bucket: this.window.appInfo.buckets.bigBucket.boocal,
                resource: this.getResource()?.public_token
            }
        });
        this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "resource-selected" : undefined }) });
        this.closeConfirm();
        } catch(e) {
            console.log(e);
        }
    };

    handleRule = async () => {
        if(!this.checkRule()) return;
        try {
        this.getRule().start_timestamp = new Date(this.getRule().start_timestamp).getTime();
        let resource = await this.window.sf.utils.$http({
            method: this.queryparams()['rule-selected'] ? "PUT" : "POST",
            url: `${this.window.appInfo.url_php}/endpoint.php/rule`,
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data : {
                private_token: this.window.usher.getPrivateToken(),
                public_token_bucket: this.window.appInfo.buckets.bigBucket.boocal,
                resource: this.getResource(),
                rule: this.getRule()
            }
        });
        this.closeRule();
        } catch(e) {
        console.log(e);
        }
        return;
    };

    deleteRule = async () => {
        try {
        await this.window.sf.utils.$http({
            method: "DELETE",
            url: `${this.window.appInfo.url_php}/endpoint.php/rule`,
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data : {
                private_token: this.window.usher.getPrivateToken(),
                public_token_bucket: this.window.appInfo.buckets.bigBucket.boocal,
                resource: this.getResource()?.public_token,
                rule: this.getRule()?.id
            }
        });
        this.closeRule();
        } catch(e) {
            console.log(e);
        }
        return;
    };

    getFormattedFrequency = (rule:any, type:any = 'frequency') => {
        if(!rule) return ' - ';
        if(type == 'frequency') {
        if(rule.frequency == 'una-tantum') return 'Singola';
        if(rule.frequency == 'weekly') return 'Settimanale';
        if(rule.frequency == 'biweekly') return 'Bisettimanale';
        if(rule.frequency == 'monthly') return 'Mensile';
        if(rule.frequency == 'annually') return 'Annuale';
        }
        if(rule.frequency == 'una-tantum' || rule.frequency == 'annually') return ' - ';
        if(type == 'day') {
        if(rule.day == 0) return "Lunedì";
        if(rule.day == 1) return "Martedì";
        if(rule.day == 2) return "Mercoledì";
        if(rule.day == 3) return "Giovedì";
        if(rule.day == 4) return "Venerdì";
        if(rule.day == 5) return "Sabato";
        if(rule.day == 6) return "Domenica";
        }
        if(rule.frequency == 'weekly') return ' - ';
        if(type == 'week') {
        if(rule.frequency == 'biweekly') {
            return rule.week == '0' ? 'Settimane pari' : 'Settimane dispari';
        }
        if(rule.week == 0) return "Prima settimana";
        if(rule.week == 1) return "Seconda settimana";
        if(rule.week == 2) return "Terza settimana";
        if(rule.week == 3) return "Quarta settimana";
        if(rule.week == 4) return "Quinta settimana";
        }
    };

    formatDate = (date:any) => {
        if(typeof date != 'object') date = new Date(date);
        return `${date?.getDate()?.toString()?.padStart(2, '0')}-${(date?.getMonth()+1)?.toString()?.padStart(2, '0')}-${date?.getFullYear()}`;
    };
    
    getResourceQuantity = () => {
        let result = [],
            start = (+this.getRule()?.from?.split(":")[0] || 0)*60 + (+this.getRule()?.from?.split(":")[1] || 0),
            slot = +this.getResource()?.configuration?.availability?.time?.value || 1;
        
        while((start+slot)<=1440) {
        start += slot;
        result.push(start);
        };
        return result;
    };

    onRuleChange = (ev:any) => {
        this.getRule().to = this.calculateTo();
    };

    calculateTo = (to:any = this.temp_slot.value) => {
        let hours = Math.floor(+to/60).toString()?.padStart(2, '0'),
            minutes = (+to%60).toString()?.padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    formatDateTime = (data, format = "DD-MM-YYYY HH:mm") => this.window.moment(data).format(format);

    formatTime = (date:any) => typeof date == 'string' ? '' : `${date?.getHours()?.toString()?.padStart(2, '0')}:${date?.getMinutes()?.toString()?.padStart(2, '0')}`;

    getMonth = () => this.window.moment(this.getCurrent()).format('MMMM YYYY');
    
    prevMonth = () => {
        let current = this.getCurrent().add(-1, 'month');
        return this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "organizer-calendar" : current.valueOf() }) });
    };

    nextMonth = () => {
        let current = this.getCurrent().add(1, 'month');
        return this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "organizer-calendar" : current.valueOf() }) });
    };

    weekOfMonth = (data) => [1,2,3,4,5][0 | this.window.moment(data).date() / 7];
    weekOfYear = (data) => this.window.moment(data).weeks();

    getDayEvents = (day = 1) =>  this.get()
    .filter(ev => this.window.moment(day).isBetween(ev.start_timestamp, ev.end_timestamp, 'day', '[]') && ev.configuration.status == 'accepted');

    getCurrent = () => {
        if(this.queryparams()['organizer-calendar']) return this.window.moment(+this.queryparams()['organizer-calendar']);
        return this.window.moment().set({hour:12,minute:0,second:0,millisecond:0});
    };

    setCurrentDay = (day:any = {}) => {
        let current = this.window.moment(day);
        return this.router.navigate([`/organizer`], { queryParams: this.changeQueryParam({ "organizer-calendar" : current.valueOf() }) });
    };

    isCurrent = (day) => this.window.moment(day).isSame(this.window.moment(), 'day');

    getCellClass = (day) => {
        let classList = [];
        if(this.isCurrent(day.day)) classList.push('current-day');
        if(day.selected) classList.push('selected-day');
        if(!day.free && !!day.number) classList.push('event');
        if(!day.number) classList.push('prev-month');
        return classList.join(" ");
    };

    getCurrentMonth = () => {
        let current = this.getCurrent(),
        startOfMonth = this.window.moment(current).startOf('month'),
        endOfMonth = this.window.moment(current).endOf('month'),
        day = startOfMonth,
        startDay = this.window.moment(current).startOf('month').day(),
        days = [],
        index = this.window.moment(current).startOf('month').day()-1,
        endDay = 7 - this.window.moment(current).endOf('month').day();
        
        days[0] = [];

        if(startDay < 1) startDay = 7;
        if(index<0) index = 6;

        while(startDay > 1) {
            days[0].push({
                day : "",
                number : "",
                disabled: true,
                selected : false
            });
            startDay -= 1;
        };

        while (day <= endOfMonth) {
            let weekIndex = Math.floor(index/7);
            days[weekIndex] = days[weekIndex] || [];
            days[weekIndex].push({
                day : day,
                number : day.format('DD'),
                selected : this.window.moment(current).isSame(day, 'day'),
                free : !this.getDayEvents(day).length
            });
            day = day.clone().add(1, 'd');
            index += 1;
        };

        while(days[days.length-1].length < 7){
            days[days.length-1].push({
                day : "",
                number : "",
                disabled: true,
                selected : false
            });
            endDay -= 1;
        };

        return days;
    };

    addBoocal = async () => {
        try {
            if(!this.getAppuntamento().configuration.boocal.resource) return;
            this.getAppuntamento().start_timestamp = new Date(this.getAppuntamento().start_timestamp).getTime();
            await this.window.sf.utils.$http({
                url : `${this.window.appInfo.url_php}/endpoint.php/book`,
                method : "POST",
                headers: { 'Content-Type': 'application/json; charset=utf-8' },
                data : {
                    name: this.getAppuntamento().name,
                    private_token : this.window.usher.getPrivateToken(),
                    public_token : this.getAppuntamento().configuration.boocal.resource,
                    quantity_time : 1,
                    quantity_value : 1,
                    start_timestamp : this.getAppuntamento().start_timestamp,
                    targets: !this.getAppuntamento().configuration.boocal.private_group ? [this.window.usher.getPublicToken(), ...(this.getAppuntamento().configuration.boocal.targets || [])] : [],
                    private_group: this.getAppuntamento().configuration.boocal.private_group,
                    configuration: {
                        status: "accepted",
                        note: this.getAppuntamento().configuration.note,
                        parent: this.window.appInfo.public_token_parent,
                        boocal: {
                            notify: {
                                webhook: `${this.window.appInfo.url_php}/endpoint.php/notify`
                            }
                        }
                    }
                }
            });
            this.close();
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: "Errore. Riprova più tardi."});
        }
    };

    handleBoocal = async (ev:any = undefined, type:any = undefined) => {
        if(!type || !ev) return;
        try {
            if(type == 'accept') {
                await this.window.sf.utils.$http({
                    url : `${this.window.appInfo.url_php}/endpoint.php/book`,
                    method : "PUT",
                    headers: { 'Content-Type': 'application/json; charset=utf-8' },
                    data : {
                        private_token : this.window.usher.getPrivateToken(),
                        event: {
                            ...ev
                        },
                        status: 'accepted'
                    }
                });
                return this.notification.success({text: "L'evento è stato confermato con successo."});
            }
            if(type == 'deny') {
                await this.window.sf.utils.$http({
                    url : `${this.window.appInfo.url_php}/endpoint.php/book`,
                    method : "DELETE",
                    headers: { 'Content-Type': 'application/json; charset=utf-8' },
                    data : {
                        private_token : this.window.usher.getPrivateToken(),
                        public_token : ev.public_token
                    }
                });
                return this.notification.success({text: "L'evento è stato cancellato con successo."});
            }
            return;
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: "Errore. Riprova più tardi."});
        }
    };

    updateDateTime = (event:any) => {
        this.getAppuntamento().start_timestamp = new Date(event.target.value);
    };

    getTargetsEvent = (targets:any = undefined) => targets.filter(e => e != this.window.usher.getPublicToken()) || [];
}